import React from 'react';
import PropTypes from 'prop-types';

const formatDate = (dateStr, withYear = true) => {
  if (!dateStr) return '';
  const d = new Date(`${dateStr}T00:00:00`);
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(withYear ? { year: 'numeric' } : {}),
  });
};

const formatDateRange = (start, end) => {
  if (!start) return '';
  if (!end || end === start) return formatDate(start);
  const sameYear = start.slice(0, 4) === end.slice(0, 4);
  return `${formatDate(start, !sameYear)} — ${formatDate(end)}`;
};

const DateRangeCell = ({ startDate, endDate }) => (
  <span className="series-date-range-cell">
    {formatDateRange(startDate, endDate)}
  </span>
);

DateRangeCell.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default DateRangeCell;
